// extracted by mini-css-extract-plugin
export default {"title":"ProgressModal_title__r7QlN"};